module.exports = __webpack_public_path__ + "static/media/rm_06-39.b00cb4eb.png";